<script lang="ts">
    // Moldura de formulário — hoje é o Zblock na densidade "titulo". Continua existindo como
    // componente próprio porque 120+ telas o chamam por este nome e com esta API; o desenho do
    // cartão mora no zblock.svelte, num lugar só.
    import Zblock from './zblock.svelte'
    import type { GridButton } from './zgrid'

    export let title: string = ''
    export let headline: string = ''
    export { className as class }
    let className = ''
    export let size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = null
    export let sizeM: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 = null
    export let acts: GridButton[] = []
</script>

<Zblock densidade="titulo" class="zframe {className}" {title} {headline} {acts} {size} {sizeM}>
    <slot />
</Zblock>
